import React from "react";
import Nav from "./Nav";
import Footer from "./footer";

import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import Events from "./Events";
import Blogs from "./Blogs";
import Gallery from "./Gallery";



import  CarouselComponent  from "./CarouselComponent";

// For Bootstrap components that require jQuery
//import '../../assets/js/plugin.js'; 








const Front=()=>{
    return(
        <>
        <Nav/>
        <CarouselComponent/>
        
       

    
     
    
  

  {/* causes section */}
  
  
      {/* <section className="ftco-section bg-light">
          <div className="container-fluid">
              <div className="row justify-content-center mb-5 pb-3">
            <div className="col-md-5 heading-section  text-center">
              <h2 className="mb-4">Our Causes</h2>
              <p>Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts.</p>
            </div>
          </div>
              <div className="row">
                  <div className="col-md-12 ">
                  <OwlCarousel className='carousel-cause ' loop margin={5} nav>
                      
                      
                          <div className="item">
                              <div className="cause-entry">
                                  <a href="#" className="img" style={{backgroundImage: "url(images/3.jpg)"}}></a>
                                  <div className="text p-3 p-md-4">
                                      <h3><a href="#">Clean water for the urban area</a></h3>
                                      <p>Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life</p>
                                      <span className="donation-time mb-3 d-block">Last donation 1w ago</span>
                          <div className="progress custom-progress-success">
                            <div className="progress-bar bg-primary" role="progressbar" style={{width: "28%"}} aria-valuenow="28" aria-valuemin="0" aria-valuemax="100"></div>
                          </div>
                          <span className="fund-raised d-block">$12,000 raised of $30,000</span>
                                  </div>
                              </div>
                          </div>
                          <div className="item">
                              <div className="cause-entry">
                                  <a href="#" className="img" style={{backgroundImage: "url(images/4.jpg)"}}></a>
                                  <div className="text p-3 p-md-4">
                                      <h3><a href="#">Clean water for the urban area</a></h3>
                                      <p>Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life</p>
                                      <span className="donation-time mb-3 d-block">Last donation 1w ago</span>
                          <div className="progress custom-progress-success">
                            <div className="progress-bar bg-primary" role="progressbar" style={{width: "28%"}} aria-valuenow="28" aria-valuemin="0" aria-valuemax="100"></div>
                          </div>
                          <span className="fund-raised d-block">$12,000 raised of $30,000</span>
                                  </div>
                              </div>
                          </div>
                          <div className="item">
                              <div className="cause-entry">
                                  <a href="#" className="img" style={{backgroundImage: "url(images/5.jpg)"}}></a>
                                  <div className="text p-3 p-md-4">
                                      <h3><a href="#">Clean water for the urban area</a></h3>
                                      <p>Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life</p>
                                      <span className="donation-time mb-3 d-block">Last donation 1w ago</span>
                          <div className="progress custom-progress-success">
                            <div className="progress-bar bg-primary" role="progressbar" style={{width: "28%"}} aria-valuenow="28" aria-valuemin="0" aria-valuemax="100"></div>
                          </div>
                          <span className="fund-raised d-block">$12,000 raised of $30,000</span>
                                  </div>
                              </div>
                          </div>
                          <div className="item">
                              <div className="cause-entry">
                                  <a href="#" className="img" style={{backgroundImage: "url(images/7.jpg)"}}></a>
                                  <div className="text p-3 p-md-4">
                                      <h3><a href="#">Clean water for the urban area</a></h3>
                                      <p>Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life</p>
                                      <span className="donation-time mb-3 d-block">Last donation 1w ago</span>
                          <div className="progress custom-progress-success">
                            <div className="progress-bar bg-primary" role="progressbar" style={{width: "28%" }}aria-valuenow="28" aria-valuemin="0" aria-valuemax="100"></div>
                          </div>
                          <span className="fund-raised d-block">$12,000 raised of $30,000</span>
                                  </div>
                              </div>
                          </div>
                          <div className="item">
                              <div className="cause-entry">
                                  <a href="#" className="img" style={{backgroundImage: "url(images/cause-5.jpg)"}}></a>
                                  <div className="text p-3 p-md-4">
                                      <h3><a href="#">Clean water for the urban area</a></h3>
                                      <p>Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life</p>
                                      <span className="donation-time mb-3 d-block">Last donation 1w ago</span>
                          <div className="progress custom-progress-success">
                            <div className="progress-bar bg-primary" role="progressbar" style={{width: "28%"}} aria-valuenow="28" aria-valuemin="0" aria-valuemax="100"></div>
                          </div>
                          <span className="fund-raised d-block">$12,000 raised of $30,000</span>
                                  </div>
                              </div>
                          </div>
                          <div className="item">
                              <div className="cause-entry">
                                  <a href="#" className="img" style={{backgroundImage: "url(images/cause-6.jpg)"}}></a>
                                  <div className="text p-3 p-md-4">
                                      <h3><a href="#">Clean water for the urban area</a></h3>
                                      <p>Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life</p>
                                      <span className="donation-time mb-3 d-block">Last donation 1w ago</span>
                          <div className="progress custom-progress-success">
                            <div className="progress-bar bg-primary" role="progressbar" style={{width: "28%"}} aria-valuenow="28" aria-valuemin="0" aria-valuemax="100"></div>
                          </div>
                          <span className="fund-raised d-block">$12,000 raised of $30,000</span>
                                  </div>
                              </div>
                          </div>
                      
                      </OwlCarousel>
                  </div>
              </div>
          </div>
          
      </section>
       */}
  
      
  
    <>
  {/* Hello world */}
  <Blogs/>

  <Gallery/>
  <Events/>
 

 
</> 

  

          
          <section className="ftco-section-3 img" style={{backgroundImage: "url(images/bg_3.jpg)"}}>
          <div className="overlay"></div>
          <div className="container">
              <div className="row d-md-flex">
              <div className="col-md-6 d-flex ">
                  <div className="img img-2 align-self-stretch" style={{backgroundImage: "url(images/bg_4.jpg)"}}></div>
              </div>
              <div className="col-md-6 volunteer pl-md-5 ">
                  <h3 className="mb-3">Be a volunteer</h3>
                  <form action="#" className="volunter-form">
              <div className="form-group">
                <input type="text" className="form-control" placeholder="Your Name"/>
              </div>
              <div className="form-group">
                <input type="text" className="form-control" placeholder="Your Email"/>
              </div>
              <div className="form-group">
                <textarea name="" id="" cols="30" rows="3" className="form-control" placeholder="Message"></textarea>
              </div>
              <div className="form-group">
                <input type="submit" value="Send Message" className="btn btn-white py-3 px-5"/>
              </div>
            </form>
              </div>    			
              </div>
          </div>
      </section>

<Footer/>







</>







    )
}
export default Front;